/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EmailNotificationBodyDTO } from '../model/models';
import { EmailNotificationDTO } from '../model/models';
import { EmailNotificationTypeDTO } from '../model/models';
import { EmailNotificationsResponseDTO } from '../model/models';
import { UpdateUserEmailNotificationBodyDTO } from '../model/models';
import { UserEmailNotificationsCountResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetEmailNotificationRequestParams {
    emailNotificationId: string;
}

export class ClsGetEmailNotificationRequestParams {
    emailNotificationId: string = undefined;
}

export interface ListEmailNotificationsRequestParams {
    read?: boolean;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsListEmailNotificationsRequestParams {
    read?: boolean = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}

export interface SendEmailNotificationRequestParams {
    emailNotificationBodyDTO: EmailNotificationBodyDTO;
}

export class ClsSendEmailNotificationRequestParams {
    emailNotificationBodyDTO: EmailNotificationBodyDTO = undefined;
}

export interface UpdateUserEmailNotificationRequestParams {
    emailNotificationId: string;
    updateUserEmailNotificationBodyDTO?: UpdateUserEmailNotificationBodyDTO;
}

export class ClsUpdateUserEmailNotificationRequestParams {
    emailNotificationId: string = undefined;
    updateUserEmailNotificationBodyDTO?: UpdateUserEmailNotificationBodyDTO = undefined;
}


export interface AdminEmailNotificationsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Count user notifications
     * Counts user notifications
*/
    countUserEmailNotifications(extraHttpRequestParams?: any): Observable<UserEmailNotificationsCountResponseDTO>;

    /**
     * Get notification
     * Receives notification detail
* @param requestParameters
     */
    getEmailNotification(requestParameters: GetEmailNotificationRequestParams, extraHttpRequestParams?: any): Observable<EmailNotificationDTO>;

    /**
     * Retrieve list of notification type
     * Get a list of notification type
*/
    getTypes(extraHttpRequestParams?: any): Observable<Array<EmailNotificationTypeDTO>>;

    /**
     * Receive list of user notifications
     * Receives list of user notification with possible filtering options
* @param requestParameters
     */
    listEmailNotifications(requestParameters: ListEmailNotificationsRequestParams, extraHttpRequestParams?: any): Observable<EmailNotificationsResponseDTO>;

    /**
     * Send a notification
     * Send a notification
* @param requestParameters
     */
    sendEmailNotification(requestParameters: SendEmailNotificationRequestParams, extraHttpRequestParams?: any): Observable<EmailNotificationDTO>;

    /**
     * Update user notification status
     * Updates detail of user notification
* @param requestParameters
     */
    updateUserEmailNotification(requestParameters: UpdateUserEmailNotificationRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
